// extracted by mini-css-extract-plugin
export default {"mainBody":"BusnessDashboard_mainBody__dxwQ8","dashbord_header":"BusnessDashboard_dashbord_header__1H3rU","dashboard_highlights":"BusnessDashboard_dashboard_highlights__AQd8X"};